(()=>{
 if(window.ebrosiaQuantityDesign)return;window.ebrosiaQuantityDesign=true;
 const selector='.product-info #xb-quantity-breaks-root .xb_quantity_breaks';
 const setText=(node,text)=>{if(node&&node.childNodes.length===1&&node.firstChild.nodeType===Node.TEXT_NODE&&node.firstChild.nodeValue!==text)node.firstChild.nodeValue=text;};
 const euro=text=>text.trim().replace(/^€\s*(.+)$/,'$1 €');
 let observer,queued=false;
 function decorate(){
  observer?.disconnect();
  document.querySelectorAll(selector).forEach(widget=>{
   widget.classList.add('eb-qb');
   setText(widget.querySelector('.xb_quantity_title'),'Mit Mengenrabatten sparen');
   widget.querySelectorAll('.xb_quantity_list_item').forEach((row,index)=>{
    row.classList.add('eb-qb-row');row.parentElement.classList.add('eb-qb-card');
    const content=row.querySelector('.xb_quantity_list_item_content');if(!content)return;
    content.classList.add('eb-qb-content');const info=content.firstElementChild;info?.classList.add('eb-qb-info');
    const title=row.querySelector('.xb_quantity_list_item_title');title?.parentElement.classList.add('eb-qb-header');
    if(title){let text=title.textContent.trim();if(/^ICH SPARE NICHT$/i.test(text))text='1 Flasche';text=text.replace(/^(?:Mengenrabatt|ab)\s+(\d+)\s+Flaschen$/i,'Ab $1 Flaschen');setText(title,text);}
    const saving=row.querySelector('.xb_quantity_list_item_label');if(saving){let text=saving.textContent.trim().replace(/^Spare\s+([\d.,]+)\s*%$/i,'$1 % sparen').replace(/(\d)\.(\d)/g,'$1,$2');setText(saving,text);}
    row.querySelectorAll('.xb_quantity_list_item_price,.xb_quantity_list_item_compare_price').forEach(el=>setText(el,euro(el.textContent)));
    const badge=row.querySelector('.xb_quantity_list_item_badge');
    row.classList.toggle('eb-qb-single',index===0&&!badge&&!saving);
    if(badge){const leaf=badge.firstElementChild;if(leaf)setText(leaf,euro(leaf.textContent.replace(/^nur\s+/i,'')));}
   });
  });
  const root=document.querySelector('main')||document.body;observer?.observe(root,{childList:true,subtree:true,characterData:true});
 }
 function schedule(){if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;decorate();});}
 observer=new MutationObserver(schedule);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',decorate,{once:true});else decorate();
 document.addEventListener('shopify:section:load',schedule);
})();
